/** @file Size of the bounding box of flat points, used to make geometric tolerances scale-free. */

/** max(width, height) of the bounding box of `p` = [x0, y0, …]; 1 when empty or degenerate. */
export function pointsScale(p: ArrayLike<number>): number {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (let i = 0; i + 1 < p.length; i += 2) {
    const x = p[i] ?? 0;
    const y = p[i + 1] ?? 0;
    minX = Math.min(minX, x);
    maxX = Math.max(maxX, x);
    minY = Math.min(minY, y);
    maxY = Math.max(maxY, y);
  }
  const size = Math.max(maxX - minX, maxY - minY);
  return size > 0 ? size : 1;
}
